uniform float uTime;
uniform float uAudioLevel;
uniform sampler2D uTexture;

varying vec2 vUv;
varying vec3 vNormal;

void main() {

  vec2 uv = vUv;
  uv.x += sin(uv.y * 10.0 + uTime * 2.0) * 0.05 * uAudioLevel;
  uv.y += cos(uv.x * 10.0 - uTime * 2.0) * 0.05 * uAudioLevel;


  float shade = 0.1 + 0.1 * sin(uTime  * 2.0);
  vec3 textureColor = texture2D(uTexture, uv).rgb;
  vec3 color = mix(textureColor, vec3(1., 1., 1.), shade);

  float lighting = dot(normalize(vNormal), normalize(vec3(0.2, 0.5, 1.0))) * 0.5 + 0.5;
  color *= lighting;

  color += vec3(1., 1., 1.) * uAudioLevel * 0.2;

  // vec3 color = textureColor;

  gl_FragColor = vec4(color, 1.0);
}
